module.exports = __webpack_public_path__ + "static/img/2en.dd9e09b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/2en.png
// module id = ljMr
// module chunks = 0